import SearchSuggestionPopup from './SearchSuggestionPopup';

export default SearchSuggestionPopup;
